export default () => {
  const homeGlobals = {}

  const globals = Object.entries(window.$App.globals.home)
  globals.forEach((global) => (homeGlobals[`$${global[0].toUpperCase()}`] = global[1]))

  return homeGlobals
}
